import { API_BASE_URL } from '../client';

export const SHARED_ENDPOINTS = {
  ENUM: {
    LIST: `${API_BASE_URL}/base/enums`,
  },
} as const;
